import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { ConnectivityStatus } from '../hooks/useConnectivity';

const STATUS_CONFIG: Record<ConnectivityStatus, { color: string; label: string }> = {
  connected: { color: 'var(--caro-success)', label: 'Connected' },
  degraded: { color: '#F6AD55', label: 'Limited connectivity' },
  disconnected: { color: 'var(--caro-emergency)', label: 'Offline' },
  checking: { color: 'var(--caro-text-light)', label: 'Checking...' },
};

interface StatusIndicatorProps {
  status: ConnectivityStatus;
}

export function StatusIndicator({ status }: StatusIndicatorProps) {
  const navigate = useNavigate();
  const config = STATUS_CONFIG[status];

  return (
    <button
      onClick={() => navigate('/connectivity')}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: 'none',
        border: 'none',
        padding: '8px 12px',
        borderRadius: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
      }}
      role="status"
      aria-label={`Connection status: ${config.label}. Tap for details.`}
    >
      <div
        style={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: config.color,
          boxShadow: status === 'connected' ? `0 0 6px ${config.color}` : 'none',
        }}
      />
      <span
        style={{
          fontSize: 'var(--font-body)',
          color: 'var(--caro-text-light)',
          fontWeight: 500,
        }}
      >
        {config.label}
      </span>
    </button>
  );
}
